import React, { useEffect, useState } from 'react'

import { Star20Filled, Star20Regular } from '@fluentui/react-icons'

import { RatingStyle } from './styles'

const { Rating } = RatingStyle

type RatingProps = {
	onClick: (rating: number) => void
	value?: number
}

export const RatingComponent = ({ onClick, value = 0 }: RatingProps) => {
	const [currentRating, setCurrentRating] = useState(0)
	const [hoverRating, setHoverRating] = useState(0)

	useEffect(() => {
		if (value) {
			setCurrentRating(value)
		}
	}, [value])

	return (
		<Rating
			onMouseEnter={() => setHoverRating(currentRating)}
			onMouseLeave={() => setHoverRating(0)}
		>
			{[...Array(5)].map((_, index) => (
				<span
					key={index}
					className={
						index < (hoverRating || currentRating) ? 'hover active' : ''
					}
					onClick={() => {
						setCurrentRating(index + 1)
						onClick(index + 1)
					}}
					onMouseEnter={() => {
						setHoverRating(index + 1)
					}}
					onMouseLeave={() => {
						setHoverRating(0)
					}}
				>
					{index < (hoverRating || currentRating) ? (
						<Star20Filled />
					) : (
						<Star20Regular />
					)}
				</span>
			))}
		</Rating>
	)
}
